import type translations from '@/locales/it-IT/translations.json';

// Derive country codes from translations.json
export type CountryCode = keyof typeof translations.countries;

// Derive state codes from translations.json
type USStateCode = keyof typeof translations.countries.US.states;

// Type for state/province code based on country
export type StateCode<T extends CountryCode> = T extends 'US' ? USStateCode : never;

// List of supported country codes (names are retrieved from i18next at runtime)
export const COUNTRY_CODES: readonly CountryCode[] = ['US', 'IT', 'SM', 'VA'] as const;

/** Default country code for address forms */
export const DEFAULT_COUNTRY_CODE: CountryCode = 'US';

/** Default max length for address2 / additional delivery information. */
export const ADDITIONAL_INFO_MAX_LENGTH = 35;

/** ERP-compatible field lengths for checkout and address-book addresses. */
export const CUSTOMER_ADDRESS_MAX_LENGTHS = {
    firstName: 20,
    lastName: 14,
    address1: 90,
    address2: 35,
} as const;
